import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import React from 'react';
import { HomeDashData, homeStyles } from '..';
import { AuthContext } from '../../../contexts/auth-context';
import { AgtStaffPermissions } from '../../../types';
import { Chart } from './chart';
import { MobileChart } from './mobile-chart';

export function AgentDashboard(props: {
  AgtNo: string;
  data: HomeDashData;
  isMobile: boolean;
}) {
  // Context
  const {
    state: { session },
  } = React.useContext(AuthContext);
  // Props
  const { AgtNo, data, isMobile } = props;

  // Check if user is agent staff account and get their permissions
  const staffAgtNo = session?.getAccessToken().decodePayload()['myStaffForAgt'];
  const staffPerms =
    session?.getAccessToken().decodePayload()['cognito:groups'] || [];
  const cantView =
    staffAgtNo && !staffPerms.includes(AgtStaffPermissions['Commissions']);

  return (
    <Paper
      sx={{
        ...homeStyles.section,
      }}
    >
      <Box
        py={3}
        sx={{
          textAlign: 'center',
          color: '#fff',
          fontSize: { xs: 18, sm: 24 },
          fontFamily: 'Lato',
          letterSpacing: 1.1,
          // fontWeight: 300,
          textTransform: 'uppercase',
          lineHeight: 1,
        }}
      >
        Top 5 Agents Leaderboard <br />{' '}
        <span style={{ fontSize: 12 }}>(Last 30 Days)</span>
      </Box>

      {isMobile ? (
        <Stack
          direction="row"
          spacing={0}
          alignItems="center"
          justifyContent="space-evenly"
          sx={{ flexWrap: 'wrap', gap: 1, pb: 2 }}
        >
          <Stack
            direction="row"
            justifyContent="space-evenly"
            alignItems="center"
            width="100%"
            pt={0}
            sx={{
              fontSize: { xs: 14, md: 18 },
              color: '#fff',
              letterSpacing: 1.1,
              fontWeight: 100,
              flexWrap: 'wrap',
              gap: 1,
            }}
          >
            <Box
              flex={1}
              sx={{
                textAlign: 'center',
              }}
            >
              CHARTS
              <Box sx={{ fontSize: 10 }}>Click to Expand</Box>
            </Box>
            <Box
              flex={1}
              sx={{
                textAlign: 'center',
              }}
            >
              TOP 5<Box sx={{ fontSize: 10 }}>Click to Expand</Box>
            </Box>
          </Stack>

          <MobileChart
            AgtNo={AgtNo}
            Title={data?.RingFocusTitle || ''}
            data={data?.RingFocus || []}
            ToolTip={data?.RingFocusToolTip || ''}
          />
          <MobileChart
            AgtNo={AgtNo}
            Title="ARC $$$"
            data={data?.GrossDeposits || []}
            isCurrency
            cantView={cantView}
          />
          <MobileChart
            AgtNo={AgtNo}
            Title="IP Production"
            data={data?.IPAP || []}
            isCurrency
          />
          <MobileChart
            AgtNo={AgtNo}
            Title="FasTracts"
            data={data?.FasTracts || []}
          />
          <MobileChart
            AgtNo={AgtNo}
            Title="Contracts"
            data={data?.Recruits || []}
          />
          <MobileChart
            AgtNo={AgtNo}
            Title="New Agent 1st IP"
            data={data?.NewIPAgents || []}
          />
        </Stack>
      ) : (
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          px={{ xs: 1, sm: 2 }}
          pb={3}
          alignItems={{ xs: 'center', md: 'stretch' }}
          justifyContent="space-evenly"
          useFlexGap
          sx={{ flexWrap: 'wrap', gap: 2 }}
        >
          <Chart
            AgtNo={AgtNo}
            Title={data?.RingFocusTitle || ''}
            data={data?.RingFocus || []}
            ToolTip={data?.RingFocusToolTip || ''}
            isCurrency
          />
          <Chart
            AgtNo={AgtNo}
            Title="ARC $$$"
            data={data?.GrossDeposits || []}
            isCurrency
            cantView={cantView}
          />
          <Chart
            AgtNo={AgtNo}
            Title="IP Production"
            data={data?.IPAP || []}
            isCurrency
          />
          <Chart AgtNo={AgtNo} Title="FasTracts" data={data?.FasTracts || []} />
          <Chart AgtNo={AgtNo} Title="Contracts" data={data?.Recruits || []} />
          <Chart
            AgtNo={AgtNo}
            Title="New Agent 1st IP"
            data={data?.NewIPAgents || []}
          />
        </Stack>
      )}
    </Paper>
  );
}
